<div
  class="spinner"
  [ngStyle]="{ width: size + 'px', height: size + 'px' }"
></div>
<p class="spinner-message">{{ message }}</p>
